import clsx from 'clsx';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  /// Read out by screen readers so a blind user knows something is happening.
  label?: string;
}

const SIZES = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-10 w-10 border-[3px]',
} as const;

export function Spinner({ size = 'md', className, label }: SpinnerProps) {
  return (
    <span className={clsx('inline-flex items-center gap-2', className)}>
      <span
        className={clsx(
          'animate-spin rounded-full border-current border-e-transparent opacity-70',
          SIZES[size],
        )}
        aria-hidden="true"
      />
      {label ? <span className="sr-only">{label}</span> : null}
    </span>
  );
}
